// ============================================================================
// appEmbedsBuiltin.ts — ВСТРОЕННЫЕ embed-поставщики (пример: youtube).
// Демонстрирует механизм «приложение/ядро расширяет другое»: ссылка youtube в
// сообщении/тексте резолвится в превью-плеер (AppEmbedPreview). Сторонние
// приложения регистрируют СВОИ поставщики (registerAppEmbed) аналогично.
// ============================================================================

import { registerAppEmbed } from '@/lib/appEmbeds';

const YOUTUBE_RE = /(?:youtube\.com\/(?:watch\?v=|shorts\/|embed\/)|youtu\.be\/)([\w-]{6,})/;

export function registerBuiltinAppEmbeds(): void {
  registerAppEmbed({
    id: 'youtube',
    appId: 'youtube',
    name: 'YouTube',
    match: [
      {
        kind: 'url',
        pattern: YOUTUBE_RE,
        extract: (m) => (m ? { videoId: m[1] } : {}),
      },
    ],
    embedUrl: (meta) => `https://www.youtube-nocookie.com/embed/${String(meta.videoId)}?rel=0`,
    openUrl: (meta) => `https://www.youtube.com/watch?v=${String(meta.videoId)}`,
  });
}
